import "../../CommonImports";
import "../../Core/core.css";
import "./Header.css";
import * as React from "react";
import { css, getSafeId } from '../../Util';
export class HeaderDescription extends React.Component {
    render() {
        return (React.createElement("div", { className: css(this.props.className, "bolt-header-description body-m secondary-text"), id: getSafeId(this.props.id) }, this.props.children));
    }
}
